import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from 'src/app/common-components/header/header.component';

 import { ColDef, GridOptions } from 'ag-grid-community';
import { AgGridModule } from 'ag-grid-angular';
import { BASE_AG_GRID_OPTIONS } from 'src/app/service/common-config';
@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css'],
  standalone: true,
  imports: [HeaderComponent, FormsModule, CommonModule,AgGridModule]
})
export class NotFoundComponent implements    OnInit {
gridOptions: GridOptions = {
  pagination: true,
  paginationPageSize: 15,
  rowSelection : 'single',
    suppressColumnVirtualisation: true,
  suppressDragLeaveHidesColumns: true,
...BASE_AG_GRID_OPTIONS,
};

  title="Page Not Found"
  constructor() { }

  ngOnInit() {
  }

}
